import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { sortArrayOfObjects } from "../utilities/methods";
import RealtimeCapture from "../realtimeUpdates";
import { push } from "connected-react-router";
import moment from "moment";
import { Link } from "react-router-dom";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { logout } from "../redux/actions/session-action-types";
import { auth } from "../firebase";
function Dashboard() {
  const products = useSelector((state) => state.product.products);
  const users = useSelector((state) => state.user.users);
  const categories = useSelector((state) => state.category.categories);
  const subCategories = useSelector((state) => state.subCategory.subCategories);
  const notifications = useSelector((state) => state.notification.notifications);
  console.log("Notifications", notifications);
  const dispatch = useDispatch();

  const [_notifications, setNotification] = useState([]),
    [orderby, setOrderBy] = useState("createdAt"),
    [sortby, setSortby] = useState("desc");

  useEffect(() => {
    let filteredNotifications = notifications.sort(
      sortArrayOfObjects(orderby, sortby)
    );
    let filteredNotificationarr = [...filteredNotifications];
    let finalFilteredNotifications = filteredNotificationarr.filter((data) => {
      return data.type === "admin";
    });
    setNotification(finalFilteredNotifications);
  }, [notifications]);

  const handleLogout = (e) => {
    e.preventDefault();
    /** Google SignOut, Call logout saga even if not logged out by google, we have to signout from our app anyway. */
    console.log("Logout >>>");
    auth
      .signOut()
      .then(() => dispatch(logout()))
      .catch(() => dispatch(logout()));
  };
  window.onscroll = function () { scrollFunctionn() };
  function scrollFunctionn() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("topbar2") && (document.getElementById("topbar2").style.top = "0");
      document.getElementById("sidebarr") && (document.getElementById("sidebarr").style.display = 'none');
      document.getElementById("mainContentWrapper") && (document.getElementById("mainContentWrapper").style.marginLeft = '0px')
    } else {
      document.getElementById("topbar2") && (document.getElementById("topbar2").style.top = "-70px");
      document.getElementById("sidebarr") && (document.getElementById("sidebarr").style.display = 'block');
      document.getElementById("mainContentWrapper") && (document.getElementById("mainContentWrapper").style.marginLeft = '252px')
    }
  }
  

  return (
    <div id="mainContentWrapper" className="mainContentWrapper">
      <div id="topbar2">

        <div className="docking-bar2 container d-flex align-items-center">


          <div className="">
            <Link to={process.env.PUBLIC_URL + "/dashboard"}>
              {/* <a href="/dashboard"> */}
              <span className="bid-logo">
                <svg
                  width="74"
                  height="61"
                  viewBox="0 0 74 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M70.2018 43.4973C68.023 47.1162 64.9715 50.1328 61.5374 52.5338C58.0927 54.9347 54.2491 56.736 50.25 58.0048C46.2431 59.26 42.073 59.964 37.8893 60.1861C33.7059 60.3788 29.4927 60.0925 25.3948 59.2415C21.3051 58.3849 17.3247 56.985 13.6925 54.9694C10.0658 52.9593 6.77622 50.3148 4.29496 47.0466C1.82178 43.7839 0.25312 39.8544 0.0283795 35.8236C-0.196387 31.7924 0.925098 27.7641 2.99671 24.3165C5.0793 20.8611 8.05282 18.0078 11.3398 15.6337C14.881 13.0747 22.7717 9.39457 25.5956 8.76796C25.6251 8.82169 24.0298 9.55229 22.3838 10.3046V10.3072H22.3809C22.3624 10.3153 22.3462 10.3233 22.3274 10.3311C22.2633 10.3606 22.1454 10.4143 21.9874 10.4866C21.9501 10.5025 21.9126 10.5212 21.875 10.5374C21.8135 10.5669 21.7468 10.5989 21.6742 10.631C21.6451 10.6417 21.6156 10.655 21.5862 10.6712C20.478 11.1744 19.4662 11.6401 19.054 11.8571C19.0352 11.8677 19.0191 11.8755 19.0032 11.8836C17.8121 12.4484 16.6317 13.0268 16.0776 13.3344C16.064 13.3425 16.0508 13.3506 16.0401 13.3584H16.0374C14.5225 14.1696 13.0662 15.077 11.6931 16.0832C8.47867 18.4388 5.68943 21.3482 3.76776 24.7262C1.85384 28.1016 0.898217 31.9556 1.20357 35.7539C1.51126 39.5494 3.0718 43.1896 5.47537 46.2114C7.88961 49.2335 11.0642 51.6691 14.5572 53.5001C18.0583 55.3363 21.8857 56.586 25.8071 57.3143C29.7337 58.0342 33.7567 58.2162 37.7367 57.9432C41.7171 57.6381 45.6517 56.8778 49.3908 55.6093C53.1221 54.3324 56.6633 52.5606 59.7735 50.2802C62.8759 48.0049 65.5498 45.2024 67.3753 41.9905C69.1927 38.7786 70.084 35.1516 69.7948 31.5838C69.4978 28.0132 68.0363 24.5924 65.7506 21.7229C63.4539 18.8511 60.4105 16.5116 57.0354 14.7425C53.6548 12.973 49.9423 11.7606 46.1307 11.0513C44.2625 10.7087 42.3674 10.4947 40.4645 10.3982C40.6115 8.95285 40.8178 7.50754 41.0801 6.07812C41.1147 6.07812 41.1523 6.08072 41.1899 6.08332C43.1436 6.24682 45.0895 6.52242 47.0113 6.92109C51.2082 7.79902 55.3035 9.23655 59.0562 11.3163C62.8008 13.3934 66.2215 16.1314 68.8232 19.5522C71.4143 22.9622 73.0792 27.111 73.3146 31.3695C73.5581 35.628 72.3699 39.8865 70.2018 43.4973Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M61.546 22.1131C61.5044 21.977 61.4363 21.8519 61.3455 21.7349C61.2583 21.6251 61.1526 21.5266 61.0237 21.4434C60.8989 21.3677 60.7779 21.3186 60.6681 21.2958L57.1116 20.577C56.7522 20.5051 56.476 20.5467 56.268 20.7056C56.0522 20.8682 55.9162 21.0953 55.8593 21.379L54.4292 28.4541L54.1756 28.0419C53.9523 27.671 53.7064 27.3307 53.4303 27.0013C53.1729 26.6948 52.8626 26.4036 52.507 26.1312C52.1476 25.8626 51.7579 25.6392 51.3191 25.454C50.8727 25.2611 50.3617 25.1059 49.798 24.9924C48.3981 24.7125 47.036 24.7125 45.7533 24.9924C44.4707 25.2724 43.294 25.7869 42.2612 26.5284C41.2322 27.2625 40.3355 28.2158 39.6052 29.3549C39.3744 29.7143 39.1664 30.0849 38.9922 30.4559V40.433C39.0829 40.6109 39.1889 40.8001 39.3328 41.0347C39.9987 42.1206 40.8803 43.0549 41.951 43.8118C43.0178 44.58 44.2702 45.1095 45.6776 45.3894C46.2187 45.4992 46.7257 45.5333 47.2252 45.4954C47.7247 45.4576 48.2089 45.3744 48.6743 45.2458C49.1322 45.1132 49.5597 44.9506 49.976 44.7463C50.392 44.5381 50.7742 44.3263 51.0995 44.1067L51.3419 43.9519L51.5386 45.0491C51.5915 45.2609 51.6331 45.4576 51.6672 45.624C51.6938 45.7716 51.7354 45.8964 51.7845 45.9987C51.8336 46.0932 51.8943 46.1613 51.9737 46.2182C52.0303 46.2598 52.1476 46.3202 52.3784 46.3693L55.477 46.9936C56.2339 47.145 56.6349 46.8916 56.7788 46.1801L61.561 22.5369C61.5914 22.3817 61.5839 22.2453 61.546 22.1131ZM52.9461 36.2371L52.9045 36.4526C52.7415 37.0885 52.4729 37.6633 52.1097 38.1591C51.7276 38.6736 51.2925 39.0824 50.7855 39.4077C50.2747 39.733 49.7036 39.9525 49.0868 40.0698C48.4813 40.1871 47.8383 40.1796 47.1836 40.047C46.5327 39.9184 45.9541 39.6726 45.4584 39.317C44.9739 38.9613 44.5767 38.53 44.278 38.0306C43.979 37.5236 43.7822 36.9521 43.6953 36.3353C43.6043 35.7035 43.6309 35.0452 43.7669 34.383C43.8995 33.7249 44.1304 33.1194 44.4556 32.5783C44.785 32.0297 45.1897 31.5681 45.6626 31.205C46.1318 30.8381 46.6691 30.5807 47.2593 30.4331C47.5696 30.3536 47.8911 30.3158 48.2204 30.3158C48.5154 30.3158 48.8219 30.3461 49.1322 30.4105C49.8056 30.5428 50.4186 30.804 50.9481 31.1784C51.4704 31.5456 51.9093 32.0072 52.2574 32.5443C52.598 33.0741 52.8326 33.6643 52.9573 34.2998C53.0784 34.9394 53.0784 35.59 52.9461 36.2371Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.4646 18.2041L23.3657 14.582L30.7377 17.6098L30.4646 18.2041Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M30.1041 19.6034L22.2805 17.8008L30.2249 18.9607L30.1041 19.6034Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.1014 16.9847L25.8132 11.832L31.5366 16.4966L31.1014 16.9847Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40.7829 4.47531C40.6705 5.01612 40.5633 5.55922 40.4671 6.10262C40.2129 7.51876 40.0121 8.9427 39.8703 10.3692C39.8302 10.7494 39.7952 11.1293 39.7631 11.5095C37.7718 11.2203 35.7724 10.9314 33.7782 10.6448C34.2679 8.32418 34.6079 5.96626 34.798 3.60547C36.3343 3.83023 37.8709 4.05238 39.4072 4.27453L40.7829 4.47531Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M42.1025 3.62153C41.9098 3.76337 41.7036 3.85727 41.4843 3.89452C41.4011 3.91071 41.3182 3.91877 41.2327 3.91877C41.1576 3.91877 41.0854 3.91331 41.0076 3.90261C38.9227 3.60014 36.8375 3.30317 34.7526 2.99522C34.5946 2.97124 34.4447 2.92559 34.308 2.85886C33.738 2.58037 33.3902 1.96215 33.4783 1.30637C33.5774 0.556991 34.2063 0 34.9453 0C35.0149 0 35.0816 0.00550013 35.1513 0.0161824C37.2553 0.307973 39.3563 0.613041 41.4574 0.928792C42.1025 1.02528 42.5093 1.43493 42.678 2.06123C42.8331 2.64189 42.5977 3.25493 42.1025 3.62153Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M40.558 14.7602C40.2316 15.0037 39.9262 15.1161 39.6024 15.1161C39.5356 15.1161 39.466 15.1109 39.3938 15.1002C37.3005 14.8004 35.2075 14.5005 33.1169 14.1902C32.2872 14.0669 31.7279 13.288 31.859 12.4664C31.9659 11.8107 32.4772 11.3262 33.101 11.2245C33.1813 11.2109 33.2642 11.2031 33.3471 11.2031C33.4193 11.2031 33.4944 11.2083 33.5692 11.219C35.6544 11.5189 37.7368 11.8188 39.822 12.1238C39.98 12.1452 40.127 12.1934 40.2637 12.2602C40.6597 12.4558 40.9567 12.8224 41.0558 13.2722C41.195 13.9011 40.9836 14.4124 40.558 14.7602Z"
                    fill="#FF7E06"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M38.02 25.4297V44.0108C38.02 44.3776 37.9293 44.6426 37.7439 44.8243C37.5509 45.0056 37.2784 45.0929 36.9041 45.0929H33.2074C32.5225 45.0929 32.2047 44.7486 32.2047 44.0108V42.6033C32.3752 42.399 32.5303 42.1907 32.6701 41.9865L32.7533 41.8692C33.3513 40.965 33.7711 39.97 33.9981 38.9104C34.2289 37.8435 34.2252 36.7463 33.9793 35.6491C33.7372 34.5898 33.2944 33.6136 32.6664 32.751L32.6172 32.6828C32.5378 32.5768 32.4621 32.4748 32.3789 32.3725C32.3183 32.3044 32.2616 32.2324 32.2047 32.1683V25.4297C32.2047 25.0628 32.2957 24.7941 32.4809 24.6162C32.6739 24.4348 32.9501 24.3438 33.321 24.3438H37.0176C37.7023 24.3438 38.02 24.6919 38.02 25.4297Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M31.5765 32.9707C31.482 32.8609 31.3873 32.7515 31.2853 32.6455C30.6648 31.9683 29.9345 31.4119 29.1134 30.9843L28.9395 30.8974L29.0378 30.7234C29.3971 30.0914 29.6395 29.3992 29.753 28.6689C29.8625 27.9273 29.8325 27.1857 29.6545 26.4025C29.4428 25.4755 29.0493 24.6357 28.4816 23.9054C27.914 23.1713 27.2218 22.5699 26.4308 22.112C25.6326 21.6503 24.7434 21.3441 23.7863 21.1965C23.4116 21.1358 23.0182 21.1055 22.6209 21.1055C22.0383 21.1055 21.4405 21.1737 20.8501 21.31L9.31038 23.9245C9.1174 23.9698 8.98108 24.0493 8.91315 24.1665C8.83373 24.2876 8.81464 24.4312 8.85624 24.6091L13.9416 47.0532C13.9794 47.2309 14.0548 47.3444 14.1683 47.4013C14.2856 47.4579 14.4295 47.4732 14.6413 47.4279L27.2065 44.5789C28.1979 44.3556 29.1097 43.9508 29.9157 43.3719C30.4415 42.9972 30.8993 42.5846 31.2778 42.1458C31.3835 42.0285 31.4783 41.915 31.5728 41.7977C31.6712 41.6692 31.7657 41.5406 31.8605 41.4043L31.8943 41.3589C31.9096 41.3363 31.9209 41.3173 31.9399 41.2945C32.4544 40.5151 32.8251 39.6374 33.0218 38.7028C33.2223 37.7683 33.2186 36.8187 33.003 35.8729C32.791 34.9384 32.4204 34.1095 31.8642 33.3379C31.7808 33.2281 31.6975 33.1183 31.6106 33.0123L31.5765 32.9707ZM16.0791 26.9852L19.9952 26.0998C20.4303 26.0053 20.7897 25.9978 21.1603 26.0394C21.5425 26.0923 21.8869 26.2096 22.1859 26.3838C22.4924 26.5614 22.7495 26.7847 22.95 27.0496C23.1583 27.318 23.3018 27.6321 23.3813 27.9764C23.4645 28.3549 23.4685 28.718 23.3928 29.0473C23.3172 29.3955 23.177 29.7095 22.9766 29.9819C22.7723 30.2693 22.5074 30.5114 22.1859 30.7044C21.8719 30.9011 21.4972 31.0487 21.0809 31.147L17.2179 32.0212L16.0791 26.9852ZM26.4461 38.2224V38.2262C26.3779 38.6159 26.2456 38.9603 26.0489 39.2818C25.8522 39.6071 25.5948 39.8911 25.2845 40.1294C24.9742 40.3715 24.6073 40.5379 24.1986 40.6286L19.4163 41.7145L18.1146 35.9749L22.8971 34.8889C23.3284 34.7982 23.7031 34.7982 24.1079 34.8889C24.5013 34.9837 24.8569 35.1351 25.1672 35.3393C25.4812 35.5511 25.7537 35.816 25.9695 36.1225C26.185 36.4252 26.3363 36.7581 26.4196 37.1099C26.499 37.4731 26.5065 37.8477 26.4461 38.2224Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M43.3776 22.0221L43.0105 21.4432C42.9764 21.39 42.946 21.3562 42.916 21.3409C42.8856 21.3221 42.8478 21.3146 42.8099 21.3146C42.7949 21.3146 42.7759 21.3184 42.7455 21.3221C42.7192 21.3259 42.6851 21.3409 42.6548 21.36C42.5526 21.4319 42.4468 21.4848 42.3333 21.5264C42.216 21.568 42.0987 21.5908 41.9699 21.5871C41.83 21.5871 41.6977 21.5529 41.5804 21.496C41.4632 21.4394 41.3647 21.3637 41.2814 21.2652C41.1982 21.1708 41.1338 21.0572 41.0922 20.9287C41.0469 20.7961 41.024 20.6562 41.0278 20.5086C41.0315 20.3648 41.0544 20.2287 41.1073 20.1001C41.1566 19.9713 41.2245 19.8577 41.3118 19.7596C41.3987 19.6648 41.5007 19.5853 41.622 19.5325C41.7431 19.4758 41.8716 19.453 42.0155 19.453C42.1441 19.4568 42.2613 19.4796 42.3749 19.525C42.4884 19.5665 42.5904 19.6232 42.6889 19.6914C42.7268 19.7179 42.7571 19.733 42.7871 19.7445C42.8137 19.7558 42.8403 19.7596 42.859 19.7633C42.9501 19.7633 43.0295 19.7104 43.0936 19.6006L43.4039 19.0974C43.4305 19.0558 43.4455 19.0142 43.4455 18.9764C43.4455 18.9157 43.4342 18.8666 43.4077 18.825C43.3814 18.7909 43.3473 18.7568 43.2979 18.7302C43.1202 18.6017 42.9272 18.4997 42.7192 18.4315C42.5147 18.3596 42.2917 18.3217 42.0418 18.3217C41.8413 18.3142 41.6483 18.3368 41.4591 18.3861C41.2702 18.4315 41.0922 18.5035 40.9296 18.5941C40.7632 18.6849 40.6156 18.7946 40.4792 18.9232C40.3394 19.0558 40.2221 19.2034 40.1236 19.3623C40.0254 19.525 39.9497 19.6989 39.8927 19.8881C39.8361 20.0773 39.8058 20.2778 39.802 20.482C39.7983 20.6903 39.8208 20.8908 39.8665 21.08C39.9193 21.273 39.9875 21.4507 40.0782 21.6133C40.1689 21.78 40.2787 21.9352 40.4151 22.0712C40.5436 22.2076 40.6875 22.3249 40.8501 22.4231C41.009 22.5213 41.1829 22.597 41.3684 22.6539C41.5576 22.7105 41.7506 22.7408 41.9511 22.7408C42.1969 22.7484 42.4277 22.7143 42.6511 22.6389C42.8706 22.567 43.0749 22.4685 43.2603 22.3474C43.3019 22.3208 43.3357 22.2945 43.3698 22.2642C43.4039 22.2301 43.4192 22.1885 43.423 22.1356C43.423 22.1241 43.4152 22.1053 43.4077 22.0787C43.3964 22.0599 43.3889 22.0371 43.3776 22.0221Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M47.6149 19.9861C47.5126 19.7325 47.3728 19.5132 47.1911 19.324C47.0097 19.1348 46.7939 18.9871 46.548 18.8736C46.2981 18.7638 46.0335 18.7034 45.7495 18.6997C45.5566 18.6959 45.3713 18.7147 45.1934 18.7601C45.0154 18.8054 44.8491 18.8698 44.6977 18.953C44.5388 19.04 44.399 19.1423 44.2742 19.2633C44.1453 19.3844 44.0356 19.5207 43.9448 19.6721C43.8541 19.8194 43.7822 19.9861 43.7253 20.16C43.6724 20.338 43.6458 20.5232 43.6421 20.7162C43.6383 20.9091 43.6574 21.0908 43.7027 21.2685C43.7481 21.4502 43.8162 21.6128 43.8995 21.768C43.9865 21.9231 44.0925 22.0632 44.2098 22.188C44.3345 22.3166 44.4706 22.4263 44.622 22.5208C44.7734 22.6118 44.936 22.6838 45.1102 22.7366C45.2879 22.7858 45.4734 22.8161 45.6663 22.8198C45.8555 22.8236 46.0372 22.8011 46.2149 22.7557C46.3891 22.7138 46.5517 22.6459 46.7107 22.5627C46.8658 22.4755 47.0018 22.3735 47.1307 22.2525C47.2592 22.1274 47.369 21.9913 47.4598 21.8437C47.5505 21.6923 47.6224 21.5297 47.6793 21.352C47.7284 21.174 47.7588 20.9923 47.7625 20.7993C47.77 20.5081 47.7209 20.2395 47.6149 19.9861ZM46.5139 21.1627C46.4723 21.2838 46.4079 21.3858 46.3322 21.4693C46.2528 21.5562 46.1583 21.6244 46.0485 21.6735C45.935 21.7226 45.8139 21.7454 45.6738 21.7417C45.5378 21.7417 45.4092 21.7114 45.2994 21.6582C45.1896 21.6053 45.0952 21.5334 45.0195 21.4427C44.9438 21.3557 44.8832 21.246 44.8416 21.1287C44.8037 21.0076 44.7849 20.875 44.7887 20.739C44.7887 20.6067 44.815 20.4778 44.8606 20.3568C44.906 20.2357 44.9701 20.1297 45.0495 20.039C45.129 19.9483 45.2275 19.8801 45.3373 19.831C45.4508 19.7778 45.5756 19.7553 45.7195 19.7553C45.8555 19.7591 45.9766 19.7894 46.0864 19.846C46.1962 19.8989 46.2869 19.9746 46.3625 20.0656C46.4345 20.16 46.4911 20.2698 46.5289 20.3908C46.5668 20.5157 46.5858 20.6442 46.5821 20.7768C46.5821 20.9129 46.5555 21.0417 46.5139 21.1627Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M54.1532 20.7971C54.1191 20.5778 54.0547 20.3848 53.9562 20.2109C53.8542 20.0405 53.7216 19.9006 53.5552 19.7909C53.3888 19.6773 53.1883 19.6091 52.95 19.5788C52.8024 19.56 52.6585 19.5638 52.5187 19.5863C52.3823 19.6091 52.2575 19.6432 52.144 19.6886C52.0267 19.7339 51.9285 19.7871 51.8413 19.8475C51.7543 19.9082 51.6861 19.9685 51.6408 20.0292C51.5879 19.9269 51.531 19.8362 51.4668 19.753C51.4024 19.6698 51.3305 19.5979 51.2473 19.5372C51.1641 19.4768 51.0696 19.4237 50.9636 19.3896C50.8613 19.3517 50.744 19.3255 50.6155 19.3064C50.4453 19.2876 50.2977 19.2876 50.1729 19.3139C50.044 19.333 49.9305 19.3671 49.8361 19.4124C49.7376 19.4578 49.6581 19.5109 49.594 19.5713C49.5258 19.6357 49.4729 19.6961 49.4351 19.7568L49.401 19.4768C49.3973 19.4428 49.3894 19.4124 49.3819 19.3821C49.3707 19.3517 49.3594 19.3255 49.3441 19.2989C49.3253 19.2723 49.3062 19.2536 49.28 19.2345C49.2571 19.2195 49.2268 19.2082 49.189 19.2044L48.716 19.1513C48.6898 19.1475 48.6594 19.1475 48.6291 19.1513C48.6025 19.1513 48.5837 19.1588 48.5572 19.1778C48.5268 19.1929 48.4968 19.2157 48.474 19.246C48.4552 19.2761 48.4399 19.3139 48.4399 19.3517L48.0314 22.8366C48.0239 22.9123 48.0351 22.9727 48.073 23.0218C48.1071 23.0674 48.1674 23.0975 48.2544 23.109L48.9622 23.1885C48.9922 23.1922 49.0226 23.1922 49.0454 23.1885C49.0679 23.1847 49.0983 23.1769 49.1248 23.1657C49.1549 23.1469 49.1777 23.1241 49.1968 23.09C49.2156 23.0559 49.2268 23.0218 49.2268 22.9842L49.4692 20.9296C49.4842 20.8349 49.5183 20.7517 49.5636 20.6801C49.609 20.6081 49.6659 20.5475 49.73 20.4984C49.7945 20.449 49.8664 20.4151 49.9383 20.3961C50.0137 20.3735 50.0894 20.3658 50.1651 20.3735C50.2483 20.3848 50.328 20.4114 50.3959 20.449C50.4604 20.4908 50.5132 20.54 50.5548 20.6044C50.5964 20.6685 50.6268 20.7405 50.6421 20.8199C50.6608 20.8993 50.6646 20.9825 50.6534 21.0698L50.415 23.1316C50.4035 23.2226 50.415 23.283 50.4453 23.3133C50.4754 23.3512 50.5323 23.3699 50.623 23.3815L51.2548 23.4571L51.2776 23.4609L51.3421 23.4647C51.4174 23.4759 51.4743 23.4609 51.5122 23.4231C51.5538 23.3852 51.5766 23.3321 51.5841 23.2489L51.8225 21.2096C51.8338 21.1151 51.8603 21.0316 51.9019 20.9562C51.9435 20.8805 51.9926 20.8199 52.0533 20.7708C52.1174 20.7254 52.1818 20.6876 52.2575 20.6648C52.3295 20.6419 52.4089 20.6344 52.4846 20.6419C52.5753 20.6535 52.651 20.6801 52.7192 20.7214C52.7874 20.7595 52.844 20.8124 52.8856 20.8768C52.9309 20.9372 52.9612 21.0091 52.9803 21.0885C52.9991 21.1717 53.0028 21.255 52.9954 21.3459L52.7533 23.404C52.7417 23.4909 52.7533 23.5516 52.7833 23.5857C52.8099 23.6198 52.8743 23.6423 52.9612 23.6539L53.68 23.7371C53.7557 23.7446 53.8126 23.7333 53.8542 23.6955C53.8921 23.6614 53.9146 23.6007 53.9262 23.525L54.1607 21.482C54.1908 21.2399 54.187 21.0128 54.1532 20.7971Z"
                    fill="#443C3F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M35.1014 17.2031C35.5137 17.2031 35.9103 17.2742 36.2913 17.4163C36.6722 17.5585 37.0085 17.7608 37.3 18.0235C37.5916 18.2861 37.8163 18.589 37.9741 18.9322C38.1319 19.2753 38.2108 19.6326 38.2108 20.004C38.2108 20.3754 38.1319 20.7327 37.9741 21.0758C37.8163 21.419 37.5916 21.7219 37.3 21.9845C37.0085 22.2471 36.6722 22.4495 36.2913 22.5917C35.9103 22.7338 35.5137 22.8049 35.1014 22.8049C34.689 22.8049 34.2924 22.7338 33.9114 22.5917C33.5305 22.4495 33.1942 22.2471 32.9027 21.9845C32.6111 21.7219 32.3864 21.419 32.2286 21.0758C32.0708 20.7327 31.9919 20.3754 31.9919 20.004C31.9919 19.6326 32.0708 19.2753 32.2286 18.9322C32.3864 18.589 32.6111 18.2861 32.9027 18.0235C33.1942 17.7608 33.5305 17.5585 33.9114 17.4163C34.2924 17.2742 34.689 17.2031 35.1014 17.2031Z"
                    fill="#FF7E06"
                  />
                </svg>
              </span>
              {/* </a> */}
            </Link>
          </div>



          <div className="side-navbar pt-2">
            <ul className="d-flex position-relative">
              <li
                className={`nav-item ${window.location.pathname === "/dashboard" ? "active" : ""
                  }`}
                onClick={() => dispatch(push("/dashboard"))}
              >
                {/* <Link to="/dashboard" className="nav-link "> */}
                <a href={process.env.PUBLIC_URL + "/dashboard"} className="nav-link  ">
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.77778 1H1V8.77778H8.77778V1Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9999 1H13.2222V8.77778H20.9999V1Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M20.9999 13.2227H13.2222V21.0004H20.9999V13.2227Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8.77778 13.2227H1V21.0004H8.77778V13.2227Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Dashboard</span>
                </a>
                {/* </Link> */}
              </li>
              <li
                className={`nav-item stroke-color ${window.location.pathname === "/registered-users" ? "active" : ""
                  }`}
                onClick={() => dispatch(push("/registered-users"))}
              >
                {/* <Link to="/registered-users"> */}
                <a className="nav-link ">
                  <svg
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.3 9.22C11.8336 8.75813 12.2616 8.18688 12.5549 7.54502C12.8482 6.90316 13 6.20571 13 5.5C13 4.17392 12.4732 2.90215 11.5355 1.96447C10.5979 1.02678 9.32608 0.5 8 0.5C6.67392 0.5 5.40215 1.02678 4.46447 1.96447C3.52678 2.90215 3 4.17392 3 5.5C2.99999 6.20571 3.1518 6.90316 3.44513 7.54502C3.73845 8.18688 4.16642 8.75813 4.7 9.22C3.30014 9.85388 2.11247 10.8775 1.27898 12.1685C0.445495 13.4596 0.00147185 14.9633 0 16.5C0 16.7652 0.105357 17.0196 0.292893 17.2071C0.48043 17.3946 0.734784 17.5 1 17.5C1.26522 17.5 1.51957 17.3946 1.70711 17.2071C1.89464 17.0196 2 16.7652 2 16.5C2 14.9087 2.63214 13.3826 3.75736 12.2574C4.88258 11.1321 6.4087 10.5 8 10.5C9.5913 10.5 11.1174 11.1321 12.2426 12.2574C13.3679 13.3826 14 14.9087 14 16.5C14 16.7652 14.1054 17.0196 14.2929 17.2071C14.4804 17.3946 14.7348 17.5 15 17.5C15.2652 17.5 15.5196 17.3946 15.7071 17.2071C15.8946 17.0196 16 16.7652 16 16.5C15.9985 14.9633 15.5545 13.4596 14.721 12.1685C13.8875 10.8775 12.6999 9.85388 11.3 9.22ZM8 8.5C7.40666 8.5 6.82664 8.32405 6.33329 7.99441C5.83994 7.66476 5.45542 7.19623 5.22836 6.64805C5.0013 6.09987 4.94189 5.49667 5.05764 4.91473C5.1734 4.33279 5.45912 3.79824 5.87868 3.37868C6.29824 2.95912 6.83279 2.6734 7.41473 2.55764C7.99667 2.44189 8.59987 2.5013 9.14805 2.72836C9.69623 2.95542 10.1648 3.33994 10.4944 3.83329C10.8241 4.32664 11 4.90666 11 5.5C11 6.29565 10.6839 7.05871 10.1213 7.62132C9.55871 8.18393 8.79565 8.5 8 8.5ZM17.74 8.82C18.38 8.09933 18.798 7.20905 18.9438 6.25634C19.0896 5.30362 18.9569 4.32907 18.5618 3.45C18.1666 2.57093 17.5258 1.8248 16.7165 1.30142C15.9071 0.77805 14.9638 0.499742 14 0.5C13.7348 0.5 13.4804 0.605357 13.2929 0.792893C13.1054 0.98043 13 1.23478 13 1.5C13 1.76522 13.1054 2.01957 13.2929 2.20711C13.4804 2.39464 13.7348 2.5 14 2.5C14.7956 2.5 15.5587 2.81607 16.1213 3.37868C16.6839 3.94129 17 4.70435 17 5.5C16.9986 6.02524 16.8593 6.5409 16.5961 6.99542C16.3328 7.44994 15.9549 7.82738 15.5 8.09C15.3517 8.17552 15.2279 8.29766 15.1404 8.44474C15.0528 8.59182 15.0045 8.7589 15 8.93C14.9958 9.09976 15.0349 9.2678 15.1137 9.41826C15.1924 9.56872 15.3081 9.69665 15.45 9.79L15.84 10.05L15.97 10.12C17.1754 10.6917 18.1923 11.596 18.901 12.7263C19.6096 13.8566 19.9805 15.1659 19.97 16.5C19.97 16.7652 20.0754 17.0196 20.2629 17.2071C20.4504 17.3946 20.7048 17.5 20.97 17.5C21.2352 17.5 21.4896 17.3946 21.6771 17.2071C21.8646 17.0196 21.97 16.7652 21.97 16.5C21.9782 14.9654 21.5938 13.4543 20.8535 12.1101C20.1131 10.7659 19.0413 9.63331 17.74 8.82Z"
                      fill="black"
                    />
                  </svg>
                  <span>Registered Users</span>
                </a>
                {/* </Link> */}
              </li>
              <li
                className={`nav-item stroke-color ${window.location.pathname === "/category" ? "active" : ""
                  }`}
                onClick={() => dispatch(push("/category"))}
              >
                {/* <Link to="/category"> */}
                <a className="nav-link ">
                  <svg
                    width="22"
                    height="18"
                    viewBox="0 0 22 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.49995 7.56007L10.4999 12.7601C10.652 12.8478 10.8244 12.894 10.9999 12.894C11.1755 12.894 11.3479 12.8478 11.4999 12.7601L20.5 7.56007C20.6515 7.47216 20.7773 7.34599 20.8647 7.19418C20.9522 7.04237 20.9982 6.87026 20.9982 6.69507C20.9982 6.51988 20.9522 6.34776 20.8647 6.19596C20.7773 6.04415 20.6515 5.91797 20.5 5.83007L11.4999 0.630069C11.3479 0.5423 11.1755 0.496094 10.9999 0.496094C10.8244 0.496094 10.652 0.5423 10.4999 0.630069L1.49995 5.83007C1.34841 5.91797 1.22262 6.04415 1.13518 6.19596C1.04775 6.34776 1.00172 6.51988 1.00172 6.69507C1.00172 6.87026 1.04775 7.04237 1.13518 7.19418C1.22262 7.34599 1.34841 7.47216 1.49995 7.56007ZM10.9999 2.65007L18 6.65007L10.9999 10.7001L3.99995 6.69007L10.9999 2.65007ZM19.5 10.4401L10.9999 15.3501L2.49995 10.4401C2.38641 10.3735 2.26086 10.3301 2.13049 10.3122C2.00012 10.2942 1.86749 10.3022 1.74022 10.3357C1.61295 10.3691 1.49352 10.4274 1.3888 10.5071C1.28408 10.5867 1.19611 10.6863 1.12995 10.8001C1.06383 10.9142 1.02094 11.0403 1.00376 11.1711C0.986578 11.3018 0.995437 11.4347 1.02983 11.5621C1.06422 11.6894 1.12346 11.8087 1.20415 11.913C1.28483 12.0174 1.38536 12.1047 1.49995 12.1701L10.4999 17.3701C10.652 17.4578 10.8244 17.504 10.9999 17.504C11.1755 17.504 11.3479 17.4578 11.4999 17.3701L20.5 12.1701C20.6145 12.1047 20.7151 12.0174 20.7958 11.913C20.8764 11.8087 20.9357 11.6894 20.9701 11.5621C21.0045 11.4347 21.0133 11.3018 20.9961 11.1711C20.979 11.0403 20.9361 10.9142 20.87 10.8001C20.8038 10.6863 20.7158 10.5867 20.6111 10.5071C20.5064 10.4274 20.387 10.3691 20.2597 10.3357C20.1324 10.3022 19.9998 10.2942 19.8694 10.3122C19.739 10.3301 19.6135 10.3735 19.5 10.4401Z"
                      fill="black"
                    />
                  </svg>
                  <span>Category</span>
                </a>
                {/* </Link> */}
              </li>
              <li
                className={`nav-item stroke-color ${window.location.pathname === "/sub-category" ? "active" : ""
                  }`}
                onClick={() => dispatch(push("/sub-category"))}
              >
                {/* <Link to="/subcategory"> */}
                <a className="nav-link ">
                  <svg
                    width="20"
                    height="22"
                    viewBox="0 0 20 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.500031 7.85866L9.50003 13.0587C9.65205 13.1464 9.82449 13.1926 10 13.1926C10.1756 13.1926 10.348 13.1464 10.5 13.0587L19.5 7.85866C19.6512 7.77141 19.7768 7.64612 19.8646 7.49525C19.9523 7.34438 19.999 7.17318 20 6.99866C20.0007 6.82245 19.9549 6.64919 19.8671 6.49641C19.7792 6.34363 19.6526 6.21677 19.5 6.12866L10.5 0.938662C10.348 0.850894 10.1756 0.804688 10 0.804688C9.82449 0.804688 9.65205 0.850894 9.50003 0.938662L0.500031 6.12866C0.347426 6.21677 0.220812 6.34363 0.133009 6.49641C0.0452054 6.64919 -0.000669067 6.82245 3.05002e-05 6.99866C0.00108387 7.17318 0.0477894 7.34438 0.135505 7.49525C0.223221 7.64612 0.348893 7.77141 0.500031 7.85866ZM10 2.99866L17 6.99866L10 10.9987L3.00003 6.99866L10 2.99866ZM18.5 10.1687L10 14.9987L1.50003 10.1287C1.3859 10.0625 1.25981 10.0197 1.12903 10.0025C0.998253 9.98529 0.865367 9.99415 0.738027 10.0285C0.610687 10.0629 0.491408 10.1222 0.387061 10.2029C0.282714 10.2835 0.195361 10.3841 0.130031 10.4987C-0.000341877 10.7283 -0.0346082 11.0001 0.0347087 11.2549C0.104026 11.5097 0.271299 11.7267 0.500031 11.8587L9.50003 17.0587C9.65205 17.1464 9.82449 17.1926 10 17.1926C10.1756 17.1926 10.348 17.1464 10.5 17.0587L19.5 11.8587C19.7288 11.7267 19.896 11.5097 19.9654 11.2549C20.0347 11.0001 20.0004 10.7283 19.87 10.4987C19.8047 10.3841 19.7173 10.2835 19.613 10.2029C19.5087 10.1222 19.3894 10.0629 19.262 10.0285C19.1347 9.99415 19.0018 9.98529 18.871 10.0025C18.7402 10.0197 18.6142 10.0625 18.5 10.1287V10.1687ZM18.5 14.1687L10 18.9987L1.50003 14.1287C1.3859 14.0625 1.25981 14.0197 1.12903 14.0025C0.998253 13.9853 0.865367 13.9941 0.738027 14.0285C0.610687 14.0629 0.491408 14.1222 0.387061 14.2029C0.282714 14.2835 0.195361 14.3841 0.130031 14.4987C-0.000341877 14.7283 -0.0346082 15.0001 0.0347087 15.2549C0.104026 15.5097 0.271299 15.7267 0.500031 15.8587L9.50003 21.0587C9.65205 21.1464 9.82449 21.1926 10 21.1926C10.1756 21.1926 10.348 21.1464 10.5 21.0587L19.5 15.8587C19.7288 15.7267 19.896 15.5097 19.9654 15.2549C20.0347 15.0001 20.0004 14.7283 19.87 14.4987C19.8047 14.3841 19.7173 14.2835 19.613 14.2029C19.5087 14.1222 19.3894 14.0629 19.262 14.0285C19.1347 13.9941 19.0018 13.9853 18.871 14.0025C18.7402 14.0197 18.6142 14.0625 18.5 14.1287V14.1687Z"
                      fill="black"
                    />
                  </svg>
                  <span>Subcategory</span>
                </a>
                {/* </Link> */}
              </li>
              <li
                className={`nav-item dropdown  ${window.location.pathname === "/add-new" ||
                    window.location.pathname === "/add-new-product" ||
                    window.location.pathname === "/products"
                    ? "active"
                    : ""
                  }`}
              >
                <UncontrolledDropdown setActiveFromChild>
                  <DropdownToggle
                    tag="a"
                    className="nav-link dropdown-toggle "
                    caret
                  >
                    <svg
                      width="22"
                      height="16"
                      viewBox="0 0 22 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7 2H20"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 8H20"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7 14H20"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 2H2.01"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 8H2.01"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2 14H2.01"
                        stroke="black"
                        stroke-width="2.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>{" "}
                    <span>Listing</span>
                  </DropdownToggle>
                  <DropdownMenu>
                    {/* <Link to="/admin/addnew"> */}
                    <DropdownItem className={`${window.location.pathname === "/add-new" ||
                        window.location.pathname === "/add-new-product"
                        ? "active"
                        : ""
                      }`} tag="a" href={process.env.PUBLIC_URL + "/add-new"}>
                      Add New Product
                    </DropdownItem>
                    {/* </Link> */}
                    {/* <Link to="/admin/list"> */}
                    <DropdownItem
                      className={`${window.location.pathname === "/products"
                          ? "active"
                          : ""
                        }`}
                      tag="a" href={process.env.PUBLIC_URL + "/products"}>
                      View
                    </DropdownItem>
                    {/* </Link> */}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
              {/* <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle "
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <svg
                  width="22"
                  height="16"
                  viewBox="0 0 22 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 2H20"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 8H20"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7 14H20"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 2H2.01"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 8H2.01"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2 14H2.01"
                    stroke="black"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Listing</span>
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item" href="/admin/addnew">
                  Add New
                </a>
                <a className="dropdown-item" href="/admin/list">
                  View
                </a>
              </div>
            </li>
            */}
              <li
                className={`nav-item ${window.location.pathname === "/change-password" ? "active" : ""
                  }`}
                onClick={() => dispatch(push("/change-password"))}
              >
                {/* <Link to="/change-password"> */}
                <a className="nav-link ">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.99996 12.456C11.3556 12.456 12.4545 11.357 12.4545 10.0014C12.4545 8.64581 11.3556 7.54688 9.99996 7.54688C8.64435 7.54688 7.54541 8.64581 7.54541 10.0014C7.54541 11.357 8.64435 12.456 9.99996 12.456Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M16.0545 12.4545C15.9456 12.7013 15.9131 12.9751 15.9613 13.2405C16.0094 13.5059 16.1359 13.7508 16.3245 13.9436L16.3736 13.9927C16.5258 14.1447 16.6465 14.3252 16.7288 14.5238C16.8112 14.7225 16.8536 14.9354 16.8536 15.1505C16.8536 15.3655 16.8112 15.5784 16.7288 15.7771C16.6465 15.9757 16.5258 16.1562 16.3736 16.3082C16.2217 16.4603 16.0412 16.581 15.8425 16.6634C15.6439 16.7457 15.431 16.7881 15.2159 16.7881C15.0009 16.7881 14.7879 16.7457 14.5893 16.6634C14.3906 16.581 14.2102 16.4603 14.0582 16.3082L14.0091 16.2591C13.8163 16.0705 13.5714 15.9439 13.3059 15.8958C13.0405 15.8477 12.7668 15.8802 12.52 15.9891C12.278 16.0928 12.0716 16.265 11.9263 16.4845C11.7809 16.704 11.7029 16.9613 11.7018 17.2245V17.3636C11.7018 17.7976 11.5294 18.2138 11.2225 18.5207C10.9157 18.8276 10.4994 19 10.0655 19C9.63146 19 9.21525 18.8276 8.90837 18.5207C8.60149 18.2138 8.42909 17.7976 8.42909 17.3636V17.29C8.42276 17.0192 8.3351 16.7565 8.17751 16.5362C8.01992 16.3159 7.79969 16.1481 7.54545 16.0545C7.29868 15.9456 7.02493 15.9131 6.75952 15.9613C6.4941 16.0094 6.24919 16.1359 6.05636 16.3245L6.00727 16.3736C5.8553 16.5258 5.67483 16.6465 5.47617 16.7288C5.27752 16.8112 5.06459 16.8536 4.84955 16.8536C4.6345 16.8536 4.42157 16.8112 4.22292 16.7288C4.02426 16.6465 3.84379 16.5258 3.69182 16.3736C3.53967 16.2217 3.41898 16.0412 3.33663 15.8425C3.25428 15.6439 3.21189 15.431 3.21189 15.2159C3.21189 15.0009 3.25428 14.7879 3.33663 14.5893C3.41898 14.3906 3.53967 14.2102 3.69182 14.0582L3.74091 14.0091C3.92953 13.8163 4.05606 13.5714 4.10419 13.3059C4.15231 13.0405 4.11982 12.7668 4.01091 12.52C3.90719 12.278 3.73498 12.0716 3.51547 11.9263C3.29596 11.7809 3.03873 11.7029 2.77545 11.7018H2.63636C2.20237 11.7018 1.78616 11.5294 1.47928 11.2225C1.1724 10.9157 1 10.4994 1 10.0655C1 9.63146 1.1724 9.21525 1.47928 8.90837C1.78616 8.60149 2.20237 8.42909 2.63636 8.42909H2.71C2.98081 8.42276 3.24346 8.3351 3.46379 8.17751C3.68412 8.01992 3.85195 7.79969 3.94545 7.54545C4.05437 7.29868 4.08686 7.02493 4.03873 6.75952C3.99061 6.4941 3.86408 6.24919 3.67545 6.05636L3.62636 6.00727C3.47422 5.8553 3.35352 5.67483 3.27118 5.47617C3.18883 5.27752 3.14644 5.06459 3.14644 4.84955C3.14644 4.6345 3.18883 4.42157 3.27118 4.22292C3.35352 4.02426 3.47422 3.84379 3.62636 3.69182C3.77834 3.53967 3.95881 3.41898 4.15746 3.33663C4.35611 3.25428 4.56905 3.21189 4.78409 3.21189C4.99913 3.21189 5.21207 3.25428 5.41072 3.33663C5.60937 3.41898 5.78984 3.53967 5.94182 3.69182L5.99091 3.74091C6.18374 3.92953 6.42865 4.05606 6.69406 4.10419C6.95948 4.15231 7.23322 4.11982 7.48 4.01091H7.54545C7.78745 3.90719 7.99383 3.73498 8.1392 3.51547C8.28457 3.29596 8.36259 3.03873 8.36364 2.77545V2.63636C8.36364 2.20237 8.53604 1.78616 8.84292 1.47928C9.14979 1.1724 9.56601 1 10 1C10.434 1 10.8502 1.1724 11.1571 1.47928C11.464 1.78616 11.6364 2.20237 11.6364 2.63636V2.71C11.6374 2.97328 11.7154 3.23051 11.8608 3.45002C12.0062 3.66953 12.2126 3.84174 12.4545 3.94545C12.7013 4.05437 12.9751 4.08686 13.2405 4.03873C13.5059 3.99061 13.7508 3.86408 13.9436 3.67545L13.9927 3.62636C14.1447 3.47422 14.3252 3.35352 14.5238 3.27118C14.7225 3.18883 14.9354 3.14644 15.1505 3.14644C15.3655 3.14644 15.5784 3.18883 15.7771 3.27118C15.9757 3.35352 16.1562 3.47422 16.3082 3.62636C16.4603 3.77834 16.581 3.95881 16.6634 4.15746C16.7457 4.35611 16.7881 4.56905 16.7881 4.78409C16.7881 4.99913 16.7457 5.21207 16.6634 5.41072C16.581 5.60937 16.4603 5.78984 16.3082 5.94182L16.2591 5.99091C16.0705 6.18374 15.9439 6.42865 15.8958 6.69406C15.8477 6.95948 15.8802 7.23322 15.9891 7.48V7.54545C16.0928 7.78745 16.265 7.99383 16.4845 8.1392C16.704 8.28457 16.9613 8.36259 17.2245 8.36364H17.3636C17.7976 8.36364 18.2138 8.53604 18.5207 8.84292C18.8276 9.14979 19 9.56601 19 10C19 10.434 18.8276 10.8502 18.5207 11.1571C18.2138 11.464 17.7976 11.6364 17.3636 11.6364H17.29C17.0267 11.6374 16.7695 11.7154 16.55 11.8608C16.3305 12.0062 16.1583 12.2126 16.0545 12.4545V12.4545Z"
                      stroke="black"
                      stroke-width="1.6"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Settings</span>
                </a>
                {/* </Link> */}
              </li>
              <li>
                {/* <div className="sidebarFooter"> */}
                <Link to={process.env.PUBLIC_URL + "/"}
                  className="nav-link logoutBtn d-flex align-items-center"
                  onClick={handleLogout}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 1.75V7.6875"
                      stroke="#C4C4C4"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.7501 2.2383C12.9923 3.04671 13.9399 4.23488 14.4518 5.6257C14.9638 7.01651 15.0125 8.53552 14.5909 9.95632C14.1693 11.3771 13.2998 12.6236 12.1121 13.5101C10.9244 14.3965 9.48202 14.8754 7.99999 14.8754C6.51795 14.8754 5.07559 14.3965 3.88788 13.5101C2.70017 12.6236 1.83071 11.3771 1.40908 9.95629C0.987458 8.53549 1.03624 7.01648 1.54816 5.62567C2.06009 4.23485 3.00774 3.04669 4.24988 2.23828"
                      stroke="#C4C4C4"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Logout</span>

                </Link>
                {/* </div> */}
              </li>
            </ul>
            {/* <div className="sidebarFooter">
            <Link to={process.env.PUBLIC_URL+"/"}>
              <a
                className="nav-link logoutBtn p-0 d-flex align-items-center"
                onClick={handleLogout}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8 1.75V7.6875"
                    stroke="#C4C4C4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.7501 2.2383C12.9923 3.04671 13.9399 4.23488 14.4518 5.6257C14.9638 7.01651 15.0125 8.53552 14.5909 9.95632C14.1693 11.3771 13.2998 12.6236 12.1121 13.5101C10.9244 14.3965 9.48202 14.8754 7.99999 14.8754C6.51795 14.8754 5.07559 14.3965 3.88788 13.5101C2.70017 12.6236 1.83071 11.3771 1.40908 9.95629C0.987458 8.53549 1.03624 7.01648 1.54816 5.62567C2.06009 4.23485 3.00774 3.04669 4.24988 2.23828"
                    stroke="#C4C4C4"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span>Logout</span>
              </a>
            </Link>
          </div> */}
          </div>
        </div>

      </div>
      <div className="dashContentHeader">
        <h5 className="dashHeading mb-0">Dashboard</h5>
      </div>
      <div className="row dashboardCardRow">
        <div className="col-lg-8">
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle1 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total No listings</h4>
                  <h3 className="card-text mb-4">{products.length}</h3>
                  <a onClick={(e) => { e.preventDefault(); dispatch(push("/products")); }} href="/" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
            {/*<div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle2 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total views</h4>
                  <h3 className="card-text mb-4">0</h3>
                  <a href="#!" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>*/}
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle3 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Registered Users</h4>
                  <h3 className="card-text mb-4">{users.length}</h3>
                  <a href="/" onClick={(e) => {
                    e.preventDefault();
                    dispatch(push("/registered-users"));
                  }} className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">

            {/*<div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle4 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">Total Revenue</h4>
                  <h3 className="card-text mb-4">$0</h3>
                  <a href="#!" className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>*/}
            <div className="col-md-6  mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle5 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">
                    Total No of Categories
                  </h4>
                  <h3 className="card-text mb-4">{categories.length}</h3>
                  <a href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(push("/category"));
                    }}
                    className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card dashboardCard shadow border-0 circleStyle6 overflow-hidden">
                <div className="card-body text-center">
                  <h4 className="card-title mb-4 pb-2">
                    Total No of Subcategories
                  </h4>
                  <h3 className="card-text mb-4">{subCategories.length}</h3>
                  <a href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(push("/sub-category"));
                    }}
                    className="card-link">
                    View all
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="row">


          </div>
        </div>
        <div className="col-lg-4">
          <div className="notificationCol bg-white border-radius-4">
            <h6 className="px-3 pt-3 pb-3 mb-0">Notifications</h6>
            {_notifications && _notifications.length === 0 && <p className="ml-3">No notification found!</p>}
            {_notifications &&
              _notifications.map((notification, index) => {
                return (
                  <div key={index} className="media mb-2">
                    <span
                      style={{
                        display: "block",
                        height: "40px",
                        width: "40px",
                        lineHeight: "60px",
                        borderRadius: "30px",
                        backgroundColor: "black",
                        color: "white",
                        textAlign: "center",
                        fontSize: "1em"
                      }}
                      className="d-flex mr-3 justify-content-center align-items-center">
                      {notification.username.charAt(0).toUpperCase()}
                      {/*<svg
                    width={40}
                    height={40}
                    viewBox="0 0 40 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx={20}
                      cy={20}
                      r={20}
                      fill="#AD0000"
                      fillOpacity="0.45"
                    />
                    <path
                      d="M15.008 14.976H16.87L19.936 20.282H20.048L23.114 14.976H24.99V25H23.114V20.058L23.226 18.378H23.114L20.566 22.872H19.432L16.87 18.378H16.758L16.87 20.058V25H15.008V14.976Z"
                      fill="white"
                    />
                  </svg>*/}
                    </span>
                    <div className="media-body">
                      <h5 className="mt-0 noti-heading mb-0">
                        <span>{notification.username},</span> {notification.message}.
                      </h5>
                      <p className="noti-date mb-0">{moment(notification.createdAt).fromNow()}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      <RealtimeCapture />
    </div>
  );
}

export default Dashboard;
